/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Tab, Nav, Alert } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import {
  getProfileDetail,
  showModal,
  updateProfile,
  updateProfileImage,
} from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { Trans } from "react-i18next";
import MobileCode from "components/MobileCode";
import i18n from "i18next";
import SwitchCompany from "./SwitchCompany";
import toastr from "toastr";

class Profile extends Component {
  uploadProfileImgRef = React.createRef();

  state = {
    profileFetched: false,
    currentTab: "#general",
    profileImageToUpload: null,
    // searchTermLang: "",
    // langListShown: false,
    // selectedLanguage: null,
    // selectedLanguageLevel: null,
    // addedLanguages: [],
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) { }

  fetchData = () => {
    this.props.getProfileDetail(
      this.onFetchBegin,
      this.onFetchSuccess,
      this.onFetchError
    );
  };

  onFetchBegin = () => {
    this.props.onProcessBegin();
  };

  onFetchError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onFetchSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      profileFetched: true,
      personalEmail: this.props.detailProfile.personalEmail,
      personalCellphone: this.props.detailProfile.personalCellphone,
      shirtSize: this.props.detailProfile.shirtSize
        ? this.props.detailProfile.shirtSize.value
        : "",
      bodySize: this.props.detailProfile.bodySize
        ? this.props.detailProfile.bodySize.value
        : "",
      tshirtSize: this.props.detailProfile.tshirtSize
        ? this.props.detailProfile.tshirtSize.value
        : "",
      pantSize: this.props.detailProfile.pantSize
        ? this.props.detailProfile.pantSize.value
        : "",
      footSize: this.props.detailProfile.footSize
        ? this.props.detailProfile.footSize.value
        : "",
      jacketSize: this.props.detailProfile.jacketSize
        ? this.props.detailProfile.jacketSize.value
        : "",
    });
  };

  onUpdateBegin = () => {
    this.props.onProcessBegin();
  };

  onUpdateError = (err) => {
    this.props.onProcessEnd();
    console.log(err);
    toastr.error(err.response.data.message);
  };

  onUpdateSuccess = (res) => {
    if (this.state.profileImageToUpload) {
      this.props.updateProfileImage(
        this.state.profileImageToUpload,
        this.onUploadBegin,
        this.onUploadSuccess,
        this.onUploadError
      );
    } else this.onUploadSuccess();
  };

  onUploadBegin = () => {
    this.props.onProcessBegin();
  };

  onUploadError = (err) => {
    this.props.onProcessEnd();
    console.log(err);
    toastr.error(err.response.data.message);
  };

  onUploadSuccess = () => {
    this.props.onProcessEnd();

    if (this.state.profileImageToUpload) {
      this.setState({ profileImageUpdated: true });
      this.props.getProfileDetail(
        this.onFetchBegin,
        this.onFetchSuccess,
        this.onFetchError
      );
    }

    if (
      this.state.personalCellphone !==
      this.props.detailProfile.personalCellphone
    ) {
      // phone code validation required
      this.props.showModal({
        modalType: "phone-code-validation",
        modalTitle: "Cep Telefonu Doğrulama",
        modalContent: <MobileCode />,
        modalFooter: null,
      });
    } else {
      this.props.showModal({
        modalType: "file-upload-success",
        modalTitle: i18n.t("10537"),
        modalContent: (
          <div>
            <Trans Desc="İşleminiz başarılı bir şekilde gerçekleştirildi">
              10570
            </Trans>
          </div>
        ),
        modalFooter: null,
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.updateProfile(
      {
        personalEmail: this.state.personalEmail,
        personalCellphone: this.state.personalCellphone,
        shirtSize: this.state.shirtSize,
        bodySize: this.state.bodySize,
        tshirtSize: this.state.tshirtSize,
        pantSize: this.state.pantSize,
        footSize: this.state.footSize,
        jacketSize: this.state.jacketSize,
      },
      this.onUpdateBegin,
      this.onUpdateSuccess,
      this.onUpdateError
    );
  };

  handleImageEdit = (e) => {
    e.preventDefault();
    this.uploadProfileImgRef.current.click();
    // console.dir(this.uploadProfileImgRef.current);
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTabbedContent = () => {
    if (!this.state.profileFetched) {
      return null;
    }

    if (this.props.location.hash) {
      if (this.props.location.hash !== this.state.currentTab) {
        this.setState({ currentTab: this.props.location.hash });
      }
      this.props.history.push("/profile");
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <Tab.Container
            id="nav-tab"
            defaultActiveKey="#general"
            activeKey={this.state.currentTab}
          >
            <nav className="scrollNav">
              <Nav variant="tabs" role="tablist">
                <Nav.Item>
                  <Nav.Link
                    onClick={() => this.setState({ currentTab: "#general" })}
                    eventKey="#general"
                  >
                    <span className="iconmford fo-icon-account-circle"></span>{" "}
                    <Trans desc="Genel Bilgiler">10059</Trans>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="nav-item nav-link"
                    onClick={() => this.setState({ currentTab: "#contact" })}
                    eventKey="#contact"
                  >
                    <span className="iconmford fo-icon-perm-phone-msg"></span>{" "}
                    <Trans desc="İletişim Bilgileri">10060</Trans>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="nav-item nav-link"
                    onClick={() => this.setState({ currentTab: "#other" })}
                    eventKey="#other"
                  >
                    <span className="iconmford fo-icon-info"></span>{" "}
                    <Trans desc="Diğer">10061</Trans>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="nav-item nav-link"
                    onClick={() => this.setState({ currentTab: "#company" })}
                    eventKey="#company"
                  >
                    <span className="iconmford fo-icon-account-circle"></span>{" "}
                    <Trans desc="Bayi">10596</Trans>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </nav>
            <Tab.Content>
              <Tab.Pane eventKey="#general">
                <div className="row">
                  <div className="col-12 col-sm-12 order-lg-1 col-md-6 col-lg-4 order-2">
                    <div className="form-group">
                      <label htmlFor="isim">
                        <Trans desc="İsim">10330</Trans>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="isim"
                        value={this.props.detailProfile.firstname}
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="tckimlikno">
                        <Trans desc="TC Kimlik">10332</Trans>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="tckimlikno"
                        value={this.props.detailProfile.identityNo}
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="egitimDurumu">
                        <Trans desc="Eğitim Durumu">10334</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          className="form-control"
                          id="education"
                          value={
                            this.props.detailProfile.educationStatus
                              ? this.props.detailProfile.educationStatus?.label
                              : ""
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 order-lg-2 col-md-12 col-lg-4 order-3">
                    <div className="form-group">
                      <label htmlFor="soyisim">
                        <Trans desc="Soyisim">10331</Trans>{" "}
                        {this.props.detailProfile.gender?.value === 50179 &&
                          "*"}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="soyisim"
                        value={this.props.detailProfile.lastname}
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="kullaniciadi">
                        <Trans desc="Kullanıcı Adı">10333</Trans>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="kullaniciadi"
                        value={this.props.detailProfile.username}
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="pozisyon">
                        <Trans desc="Pozisyon">10336</Trans>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="pozisyon"
                        value={this.props.detailProfile.position.name}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 order-lg-3 col-md-6 col-lg-4 order-1 text-right">
                    <div className="imgBackground">
                      <label
                        className="text-left d-block"
                        style={{ background: "white" }}
                      >
                        <Trans desc="Profil Fotoğrafı">10329</Trans>
                      </label>
                      <div
                        className="profilImgArea"
                        style={{
                          backgroundImage: `url(${this.state.profileImageToUpload
                            ? URL.createObjectURL(
                              this.state.profileImageToUpload
                            )
                            : this.props.file
                              ? this.props.file.binary
                              : "img/ford-gelisim-akademisi-avatar.svg"
                            })`,
                        }}
                      >
                        <input
                          accept="image/*"
                          id="uploadProfileImg"
                          type="file"
                          ref={this.uploadProfileImgRef}
                          onChange={(e) => {
                            // let reader = new FileReader();
                            // reader.onloadend = () => {
                            //   reader.readAsDataURL(e.target.files[0]);
                            //   console.log(reader.result);
                            // };

                            this.setState({
                              profileImageToUpload: e.target.files[0],
                            });
                          }}
                        />
                        <a id="upload_imglink" onClick={this.handleImageEdit}>
                          <div
                            className="tooltipProfilPic"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Düzenle"
                          >
                            <span className="iconmford fo-icon-edit"></span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  {/* <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="profilAreaRowSeperator"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group searchable">
                      <label htmlFor="yabanciDil">Yabancı Dil</label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-search"></span>
                        <input
                          type="text"
                          name="yabanciDil"
                          id="yabanciDil"
                          onChange={this.langTypeHandler}
                          className="form-control"
                          placeholder="Bul"
                          value={
                            this.state.selectedLanguage
                              ? this.state.selectedLanguage
                              : this.state.searchTermLang
                          }
                        />
                      </div>
                      {this.renderForeignLanguages()}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="yabanciDilSeviye">Yabancı Dil Seviyesi</label>
                      <div
                        className="inner-addon right-addon"
                        id="yabanciDilSeviyeAlani"
                      >
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          className="custom-select"
                          id="yabanciDilSeviye"
                          onChange={(e) => this.selectLangLevel(e.target.value)}
                        >
                          <option value="0">Seviye Seçiniz.</option>
                          <option value="Başlangıç Seviyesi">
                            Başlangıç Seviyesi
                          </option>
                          <option value="Orta Seviye">Orta Seviye</option>
                          <option value="İleri Seviye">İleri Seviye</option>
                        </select>
                      </div>
                      <span
                        className="iconmford fo-icon-add"
                        id="yabanciDilEkle"
                        onClick={this.addLanguage}
                      ></span>
                    </div>
                  </div>
                  {this.renderAddedLanguages()}
                </div> */}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="#contact">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="kisiseleposta">
                        <Trans desc="Kişisel E-Posta">10337</Trans>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="kisiseleposta"
                        value={this.state.personalEmail}
                        onChange={(e) => {
                          this.setState({ personalEmail: e.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="iseposta">
                        <Trans desc="İş E-Posta">10338</Trans> **
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="iseposta"
                        value={this.props.detailProfile.companyEmail}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="kisiselceptel">
                        <Trans desc="Kişisel Cep Telefonu">10353</Trans> **
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="kisiselceptel"
                        value={this.state.personalCellphone}
                        onChange={(e) => {
                          this.setState({ personalCellphone: e.target.value });
                        }}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="profilAreaRowSeperator"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="sehir">
                        <Trans desc="Şehir">10339</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          value={
                            this.props.detailProfile.city
                              ? this.props.detailProfile.city.name
                              : ""
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="ilce">
                        <Trans desc="İlçe">10340</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          className="form-control"
                          id="district"
                          value={
                            this.props.detailProfile.district
                              ? this.props.detailProfile.district
                              : ""
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="adres1">
                        <Trans desc="Adres">10341</Trans> *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="adres1"
                        value={this.props.detailProfile.street}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="#other">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="dogumYeri">
                        <Trans desc="Doğum Yeri">10342</Trans> *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="dogumYeri"
                        value={this.props.detailProfile.birthplace || ""}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="dogumTarihi">
                        <Trans desc="Doğum Tarihi">10343</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="icon-icon-style-calendar"></span>
                        <input
                          type="text"
                          className="form-control datepicker"
                          id="dogumTarihi"
                          value={this.renderDate(
                            this.props.detailProfile.birthdate
                          )}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="cinsiyet">
                        <Trans desc="Cinsiyet">10344</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          className="form-control"
                          id="gendder"
                          value={this.props.detailProfile.gender?.label}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="medeniDurum">
                        <Trans desc="Medeni Durum">10345</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          className="form-control"
                          id="maritialStatus"
                          value={this.props.detailProfile.maritialStatus?.label}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="ehliyet">
                        <Trans desc="Ehliyet">10346</Trans> *
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          className="form-control"
                          id="drivingLicence"
                          value={
                            this.props.detailProfile.drivingLicense
                              ? this.props.detailProfile.drivingLicense?.label
                              : ""
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="shirtSize">
                        <Trans desc="Gömlek Boyu">10347</Trans>
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          id="shirtSize"
                          className="custom-select"
                          onChange={(e) =>
                            this.setState({ shirtSize: e.target.value })
                          }
                          value={this.state.shirtSize}
                        >
                          <option value="">
                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                          </option>
                          <option value="36">S/36</option>
                          <option value="38">S/38</option>
                          <option value="40">M/40</option>
                          <option value="42">M/42</option>
                          <option value="44">L/44</option>
                          <option value="46">L/46</option>
                          <option value="48">XL/48</option>
                          <option value="50">XL/50</option>
                          <option value="52">XXL/52</option>
                          <option value="54">XXL/54</option>
                          <option value="56">XXXL/56</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="pantSize">
                        <Trans desc="Pantolon Boyu">10348</Trans>
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          className="custom-select"
                          id="pantSize"
                          onChange={(e) =>
                            this.setState({ pantSize: e.target.value })
                          }
                          value={this.state.pantSize}
                        >
                          <option value="">
                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                          </option>
                          <option value="36">S/36</option>
                          <option value="38">S/38</option>
                          <option value="40">M/40</option>
                          <option value="42">M/42</option>
                          <option value="44">L/44</option>
                          <option value="46">L/46</option>
                          <option value="48">XL/48</option>
                          <option value="50">XL/50</option>
                          <option value="52">XXL/52</option>
                          <option value="54">XXL/54</option>
                          <option value="56">XXXL/56</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="tshirtSize">
                        <Trans desc="T-Shirt Boyu">10349</Trans>
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          id="tshirtSize"
                          className="custom-select"
                          onChange={(e) =>
                            this.setState({ tshirtSize: e.target.value })
                          }
                          value={this.state.tshirtSize}
                        >
                          <option value="">
                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                          </option>
                          <option value="1">XS</option>
                          <option value="2">S</option>
                          <option value="3">M</option>
                          <option value="4">L</option>
                          <option value="5">XL</option>
                          <option value="6">XXL</option>
                          <option value="7">XXXL</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="shirtSize">
                        <Trans desc="Ceket Boyu">10350</Trans>
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          id="jacketSize"
                          className="custom-select"
                          onChange={(e) =>
                            this.setState({ jacketSize: e.target.value })
                          }
                          value={this.state.jacketSize}
                        >
                          <option value="">
                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                          </option>
                          <option value="1">XS</option>
                          <option value="2">S</option>
                          <option value="3">M</option>
                          <option value="4">L</option>
                          <option value="5">XL</option>
                          <option value="6">XXL</option>
                          <option value="7">XXXL</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="footSize">
                        <Trans desc="Ayakkabı Numarası">10351</Trans>
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          id="footSize"
                          className="custom-select"
                          onChange={(e) =>
                            this.setState({ footSize: e.target.value })
                          }
                          value={this.state.footSize}
                        >
                          <option value="">
                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                          </option>
                          <option value="34">34</option>
                          <option value="35">35</option>
                          <option value="36">36</option>
                          <option value="37">37</option>
                          <option value="38">38</option>
                          <option value="39">39</option>
                          <option value="40">40</option>
                          <option value="41">41</option>
                          <option value="42">42</option>
                          <option value="43">43</option>
                          <option value="44">44</option>
                          <option value="45">45</option>
                          <option value="46">46</option>
                          <option value="47">47</option>
                          <option value="48">48</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="shirtSize">
                        <Trans desc="Vücut Ölçüsü">10352</Trans>
                      </label>
                      <div className="inner-addon right-addon">
                        <span className="iconmford fo-icon-expand-more"></span>
                        <select
                          id="bodySize"
                          className="custom-select"
                          onChange={(e) =>
                            this.setState({ bodySize: e.target.value })
                          }
                          value={this.state.bodySize}
                        >
                          <option value="">
                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                          </option>
                          <option value="1">XS</option>
                          <option value="2">S</option>
                          <option value="3">M</option>
                          <option value="4">L</option>
                          <option value="5">XL</option>
                          <option value="6">XXL</option>
                          <option value="7">XXXL</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="profilAreaRowSeperator"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="form-group searchable">
                    <label htmlFor="hobiler" className="d-block">
                      Hobiler
                    </label>
                    <div
                      className="inner-addon right-addon"
                      id="hobiSearchArea"
                    >
                      <span className="iconmford fo-icon-search"></span>
                      <input
                        type="text"
                        name="hobiler"
                        id="hobiler"
                        onkeyup="filterFunction(this,event)"
                        className="form-control"
                        placeholder="Bul"
                      />
                    </div>
                    <ul id="hobiListe">
                      <li>Balık Tutmak</li>
                      <li>Engelli Binicilik</li>
                      <li>Kitesurfing</li>
                      <li>Koleksiyon Yapmak</li>
                    </ul>
                    <span className="iconmford fo-icon-add" id="hobiEkle"></span>
                  </div>
                </div>
                <div
                  className="col-12 col-sm-12 col-md-12 col-lg-12"
                  id="hobiListesi"
                >
                  <div className="hobi">
                    <div className="event">
                      <ul className="eventItems">
                        <li>
                          <a onclick="editHobi(this)">
                            <span className="icon-icon-style-edit"></span>
                          </a>
                        </li>
                        <li>
                          <a onclick="deleteHobi(this)">
                            <span className="icon-icon-style-delete"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="text">Balık Tutmak</div>
                  </div>
                  <div className="hobi">
                    <div className="event">
                      <ul className="eventItems">
                        <li>
                          <a onclick="editHobi(this)">
                            <span className="icon-icon-style-edit"></span>
                          </a>
                        </li>
                        <li>
                          <a onclick="deleteHobi(this)">
                            <span className="icon-icon-style-delete"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="text">Engelli Binicilik</div>
                  </div>
                  <div className="hobi">
                    <div className="event">
                      <ul className="eventItems">
                        <li>
                          <a onclick="editHobi(this)">
                            <span className="icon-icon-style-edit"></span>
                          </a>
                        </li>
                        <li>
                          <a onclick="deleteHobi(this)">
                            <span className="icon-icon-style-delete"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="text">Kitesurfing</div>
                  </div>
                  <div className="hobi">
                    <div className="event">
                      <ul className="eventItems">
                        <li>
                          <a onclick="editHobi(this)">
                            <span className="icon-icon-style-edit"></span>
                          </a>
                        </li>
                        <li>
                          <a onclick="deleteHobi(this)">
                            <span className="icon-icon-style-delete"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="text">Koleksiyon Yapmak</div>
                  </div>
                </div>
              </div> */}
              </Tab.Pane>
              <Tab.Pane eventKey="#company">
                <SwitchCompany />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </form>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="profilAreaRowSeperator"></div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="row" style={{ alignItems: "flex-start" }}>
              <div className="col-sm-12 col-md-6 col-lg-6">
                {this.state.currentTab === "#general" && (
                  <Alert variant="info">
                    <Trans desc="Bayi IK sorumlunuz ile iletişime geçebilirsiniz">
                      10516
                    </Trans>
                  </Alert>
                )}
                {this.state.currentTab === "#contact" && (
                  <div>
                    <Alert variant="info">
                      <Trans desc="Bayi IK sorumlunuz ile iletişime geçebilirsiniz">
                        10516
                      </Trans>
                    </Alert>
                    <Alert variant="info">
                      <Trans desc="Bayi Eğitim Yöneticiliği ile iletişime geçiniz">
                        10515
                      </Trans>
                    </Alert>
                  </div>
                )}
                {this.state.currentTab === "#other" && (
                  <Alert variant="info">
                    <Trans desc="Bayi IK sorumlunuz ile iletişime geçebilirsiniz">
                      10516
                    </Trans>
                  </Alert>
                )}
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 text-right">
                {this.state.currentTab !== "#company" && (
                  <button
                    type="submit"
                    className="btn btn-kaydet"
                    onClick={(e) => this.handleSubmit(e)}
                  >
                    <Trans desc="Kaydet">10328</Trans>
                  </button>
                )}
              </div>
            </div>

            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Alert variant="info">Bu bilgilier bayi ik yöneticisi tarafından değiştirilebilir.</Alert>
              <button
                type="submit"
                className="btn btn-kaydet"
                onClick={(e) => this.handleSubmit(e)}
              >
                <Trans desc="Kaydet">10328</Trans>
              </button>
            </div> */}
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <Trans desc="Profil">10405</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Genel Bilgiler">10059</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Profil">10405</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    detailProfile: state.profile.detail,
    modal: state.modal,
    application: state.application,
    file: state.files.find((f) => {
      return f.id === state.profile.general.imagePath;
    }),
  };
};

export default connect(mapStateToProps, {
  getProfileDetail,
  showModal,
  updateProfile,
  updateProfileImage,
})(requireAuth(containsLongRunningProcess(Profile)));
